import { TitleCell, TitleRow } from '../../../../components/ReusableComponents/Table'
import layoutStyles from '../Billing.module.scss'

const BillingTitleRow = () => (
  <TitleRow
    className={layoutStyles.billingGridRowTitle}
    style={{ position: 'sticky', top: 0, zIndex: 2 }}
  >
    <TitleCell textAlign="flex-start" />
    <TitleCell textAlign="flex-start">#</TitleCell>
    <TitleCell textAlign="flex-start">Id</TitleCell>
    <TitleCell textAlign="flex-start">Hotel name</TitleCell>
    <TitleCell textAlign="flex-start">CSM</TitleCell>
    <TitleCell textAlign="flex-start">Invoice</TitleCell>
    <TitleCell textAlign="flex-start">Balance state</TitleCell>
    <TitleCell textAlign="flex-start">Invoice date</TitleCell>
    <TitleCell textAlign="flex-start">Due date</TitleCell>
    <TitleCell textAlign="flex-start">Aging (days)</TitleCell>
    <TitleCell textAlign="flex-start">Default payment method</TitleCell>
    <TitleCell textAlign="flex-start">Invoice amount</TitleCell>
    <TitleCell textAlign="flex-start">Overdue amount</TitleCell>
    <TitleCell textAlign="flex-start">PTP date</TitleCell>
    <TitleCell textAlign="flex-start">Pipedrive</TitleCell>
  </TitleRow>
)

export default BillingTitleRow
